export default "__VITE_ASSET__BJaHQ3kA__"